import React from "react";

const getThemeColors = (theme) => theme === 'dark' ? {
  background: '#222831',
  cardBg: '#121416',
  text: '#ffffff',
  textSecondary: '#e6eef7',
  textMuted: '#9aa4ad',
  inputBg: '#111315',
  borderColor: 'rgba(255,255,255,0.05)',
} : {
  background: '#f0f2f5',
  cardBg: '#ffffff',
  text: '#1a1d23',
  textSecondary: '#2c3e50',
  textMuted: '#6c757d',
  inputBg: '#f8f9fa',
  borderColor: 'rgba(0,0,0,0.1)',
};

export default function MyAccount({ onBack, theme, BRAND }) {
  const themeColors = getThemeColors(theme);

  return (
    <div style={{ padding: 28, background: themeColors.background, minHeight: '100vh' }}>
      <img 
        src="/logo_wordmark.png" 
        alt="Loopen" 
        style={{ 
          height: 48, width: 'auto', objectFit: 'contain',
          filter: theme === 'dark' ? 'invert(1) brightness(1.2)' : 'none',
          marginBottom: 24
        }} 
      />
      <button
        onClick={onBack}
        style={{
          padding: '8px 16px',
          borderRadius: 8,
          background: BRAND.primary,
          border: 'none',
          cursor: 'pointer',
          color: '#fff',
          fontWeight: 'normal',
          fontSize: 14,
          marginBottom: 24
        }}
      >
        ← Back
      </button>
      <h1 style={{ margin: 0, fontSize: 24, color: themeColors.text }}>My Account</h1>
    </div>
  );
}